import { render, staticRenderFns } from "./UpdateRecords.vue?vue&type=template&id=6d2cc1a3&scoped=true"
import script from "./UpdateRecords.vue?vue&type=script&lang=js"
export * from "./UpdateRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2cc1a3",
  null
  
)

export default component.exports